import React, { useState } from 'react';
import { FileText, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const CapabilitiesDocButton = () => {
  const [busy, setBusy] = useState(false);
  const download = async () => {
    setBusy(true);
    try {
      const res = await fetch(`${API_URL}/api/admin/capabilities-doc`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('session_token')}` },
      });
      if (!res.ok) throw new Error('Could not download the document');
      const url = URL.createObjectURL(await res.blob());
      const a = Object.assign(document.createElement('a'), { href: url, download: 'Schedule_Guru_Capabilities.docx' });
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (e) {
      toast.error(e.message);
    } finally {
      setBusy(false);
    }
  };
  return (
    <button type="button" onClick={download} disabled={busy}
      className="flex items-center gap-1.5 text-sm text-white/80 hover:text-white transition-colors disabled:opacity-60"
      title="Download the Schedule Guru capabilities document (.docx)" data-testid="admin-capabilities-doc-btn">
      {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <FileText className="w-4 h-4" />}
      <span className="hidden sm:inline">Capabilities doc</span>
    </button>
  );
};
